import Navigation from '@/components/navigation/Navigation'
import AdminDashboard from '@/components/admin/AdminDashboard'
import AdminDeviceList from '@/components/admin/devices/DeviceList'
import AdminDeviceForm from '@/components/admin/devices/DeviceForm'
import AdminWatchList from '@/components/admin/watches/WatchList'
import AdminWatchForm from '@/components/admin/watches/WatchForm'
import AdminUserList from '@/components/admin/users/UserList'
import AdminSubscriptionList from '@/components/admin/subscriptions/SubscriptionList'
import AdminServiceList from '@/components/admin/services/ServiceList'
import AdminServiceForm from '@/components/admin/services/ServiceForm'
import AdminReadingTypesList from '@/components/admin/readingtypes/ReadingTypesList'
import AdminSSNumberTypesList from '@/components/admin/ssnumbertypes/SSNumberTypesList'
import AdminDiseaseNamesList from '@/components/admin/diseasenames/DiseaseNamesList'
import AdminMDCategoriesList from '@/components/admin/mdcategories/MedicalDocumentsCategoriesList'
import AdminStaticContentTerms from '@/components/admin/statics/AdminStaticContentTerms'
import AdminHelpContent from '@/components/admin/help/AdminHelpContent'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/admin',
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'dashboard',
				name: 'AdminDashboard',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminDashboard,
					menu: Navigation
				}
			},
			{
				path: 'devices',
				name: 'AdminDeviceList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminDeviceList,
					menu: Navigation
				}
			},
			{
				path: 'devices/add',
				name: 'AdminDeviceAdd',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminDeviceForm,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						action: 'add'
					}),
					menu: true
				}
			},
			{
				path: 'devices/:device_id/edit',
				name: 'AdminDeviceEdit',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminDeviceForm,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						device_id: route.params.device_id,
						data: route.params.data,
						action: 'edit'
					}),
					menu: true
				}
			},
			{
				path: 'watches',
				name: 'AdminWatchList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminWatchList,
					menu: Navigation
				}
			},
			{
				path: 'watches/add',
				name: 'AdminWatchAdd',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminWatchForm,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						action: 'add'
					}),
					menu: true
				}
			},
			{
				path: 'watches/:watch_id/edit',
				name: 'AdminWatchEdit',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminWatchForm,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						watch_id: route.params.watch_id,
						data: route.params.data,
						action: 'edit'
					}),
					menu: true
				}
			},
			{
				path: 'users',
				name: 'AdminUserList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminUserList,
					menu: Navigation
				}
			},
			{
				path: 'subscriptions',
				name: 'AdminSubscriptionList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminSubscriptionList,
					menu: Navigation
				}
			},
			{
				path: 'services',
				name: 'AdminServiceList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminServiceList,
					menu: Navigation
				}
			},
			{
				path: 'services/add',
				name: 'AdminServiceAdd',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminServiceForm,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						action: 'add'
					}),
					menu: true
				}
			},
			{
				path: 'services/:service_id/edit',
				name: 'AdminServiceEdit',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminServiceForm,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						service_id: route.params.service_id,
						data: route.params.data,
						action: 'edit'
					}),
					menu: true
				}
			},
			{
				path: 'readingtypes',
				name: 'AdminReadingTypesList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminReadingTypesList,
					menu: Navigation
				}
			},
			{
				path: 'ssnumbertypes',
				name: 'AdminSSNumberTypesList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminSSNumberTypesList,
					menu: Navigation
				}
			},
			{
				path: 'diseasenames',
				name: 'AdminDiseaseNamesList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminDiseaseNamesList,
					menu: Navigation
				}
			},
			{
				path: 'mdcategories',
				name: 'AdminMDCategoriesList',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminMDCategoriesList,
					menu: Navigation
				}
			},
			{
				path: 'static/use-policy',
				name: 'AdminStaticContentUsePolicy',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminStaticContentTerms,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						name: 'use-policy'
					}),
					menu: true
				}
			},
			{
				path: 'static/privacy-policy',
				name: 'AdminStaticContentPrivacyPolicy',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminStaticContentTerms,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						name: 'privacy-policy'
					}),
					menu: true
				}
			},
			{
				path: 'static/terms',
				name: 'AdminStaticContentTerms',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminStaticContentTerms,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						name: 'terms'
					}),
					menu: true
				}
			},
			{
				path: 'help',
				name: 'AdminHelpContent',
				meta: {
					requiredAuth: true,
					requiredRoles: ['admin']
				},
				components: {
					default: AdminHelpContent,
					menu: Navigation
				}
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/admin.js